import { useNavigate } from 'react-router-dom'
import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { appGetAllEvent } from '../../store/event'
import { eventExportColumns } from '../../config/exportColumns/eventExportColumns'
import { useDispatch } from 'react-redux'

function Event() {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Events</div>
					<div>
						<ExportButton
							fetchAction={params => dispatch(appGetAllEvent({ ...params, loading: false }))}
							filters={{}}
							columns={eventExportColumns}
							fileName="Events"
							sheetName="Event List"
							buttonText="Export Events"
						/>
						<button
							className="btn btn-labeled btn-success"
							type="button"
							style={{ fontSize: '17px', marginLeft: '10px' }}
							onClick={() => navigate('/event/new')}
						>
							<span className="btn-label">
								<em className="fas fa-plus"></em>
							</span>
							New Event
						</button>
					</div>
				</div>
				<TableFilter />
			</div>
		</>
	)
}

export default Event
